module.exports = __webpack_public_path__ + "static/media/phone-alt-solid.6d452db4.svg";